module.exports = __webpack_public_path__ + "static/media/lock-open-alt.7638e5d4.svg";